// dynamic env variables (fetched at container startup) mixed with build time env variables


// dynamic env variables (fetched at container startup) mixed with build time env variables
// @ts-ignore
export const env = { ...import.meta.env, ...(typeof window !== 'undefined' && window ? window['env'] : {}) }